export interface faq {
    tema: string,
    titulo: string,
    descricao: string
}

export const listaFaq: faq[] = [
    {
        tema: 'extratoBancario',
        titulo: 'Por que não estou conseguindo importar um Extrato Bancário?',
        descricao: `Inicialmente podemos estar encontrando duas possíveis situações: 
         1. É necessário se atentar se existe uma Conta Bancária vinculada a sua conta para selecionar no início do processo. 
         2. Pode não estar conseguindo vincular uma data anterior a criação da sua conta.`
    },
    {
        tema: 'Header II',
        titulo: 'Header II',
        descricao: `Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam
                rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt
                explicabo. <br>
                Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores
                eos qui ratione voluptatem sequi nesciunt. Consectetur, adipisci velit, sed quia non numquam eius modi.`
    },
    {
        tema: 'Header III',
        titulo: 'Header III',
        descricao: `At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum
                deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non
                provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. <br>
                Et harum quidem rerum facilis est
                et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo
                minus.`
    }
]